/**
 * Inline images authored in the replicated-page rich-text editor are stored
 * with an ORIGIN-PROOF relative src (`/replicated-page/image?key=…`) so the
 * saved HTML survives domain changes and multi-domain tenants. Each consumer
 * (admin editor/preview, member render) absolutizes against ITS api base right
 * before display, and the admin editor relativizes again on change before save.
 */
// Sibling path (NOT nested under /replicated-page/) so it can never shadow the
// campaign-slug route GET /replicated-page/:slug — Fastify prefers static
// segments, so a page whose slug matched a nested static path would 400.
export const REPLICATED_IMAGE_PATH = '/replicated-page-image';

/** `/replicated-page/image?key=…` srcs → `<apiBase>/replicated-page/image?key=…`. */
export function absolutizeReplicatedImageSrcs(html: string, apiBase: string): string {
  const base = apiBase.replace(/\/$/, '');
  return html.replaceAll(`src="${REPLICATED_IMAGE_PATH}?`, `src="${base}${REPLICATED_IMAGE_PATH}?`);
}

/** Inverse of {@link absolutizeReplicatedImageSrcs} — canonicalize before save. */
export function relativizeReplicatedImageSrcs(html: string, apiBase: string): string {
  const base = apiBase.replace(/\/$/, '');
  return html.replaceAll(`src="${base}${REPLICATED_IMAGE_PATH}?`, `src="${REPLICATED_IMAGE_PATH}?`);
}
